window.addEventListener('DOMContentLoaded', () => {

    if (window.matchMedia("(min-width: 769px)").matches) {
        const footer = document.getElementById('footer');

        const options = {
            root: null,
            rootMargin: '-16px',
            threshold: 0
        };

        const observer = new IntersectionObserver(stopFixed, options);

        observer.observe(footer);

        function stopFixed(changes) {

            const downloadButton = document.querySelector('#downloadButton');

            changes.forEach(change => {

                if (change.isIntersecting) {
                    downloadButton.classList.add('is-static');
                } else {
                    downloadButton.classList.remove('is-static');
                }
            });
        }
    }
})
